"use client";

import { Badge } from "@universe/ui/components/badge";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

interface CollapsibleDetailSectionProps {
  title: string;
  showLabel: string;
  hideLabel: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export default function CollapsibleDetailSection({
  title,
  showLabel,
  hideLabel,
  children,
  defaultOpen = false,
}: CollapsibleDetailSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <Badge
          variant="outline"
          className="text-sm py-1 cursor-pointer hover:bg-brand-primary/5"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? hideLabel : showLabel}
        </Badge>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
